/* tslint:disable */
/* eslint-disable */
/**
 * LoudHippo API
 * An API for LoudHippo Platform.
 *
 * The version of the OpenAPI document: 1.0
 * Contact: hello@loudhippo.io
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @enum {string}
 */

export const AccountStatus = {
    Active: 'Active',
    Cancelled: 'Cancelled',
    Disabled: 'Disabled'
} as const;

export type AccountStatus = typeof AccountStatus[keyof typeof AccountStatus];



